<template>
  <div>
    <div class="row">
      <div
        class="px-10 py-5"
        role="button"
        data-bs-toggle="collapse"
        :data-bs-target="`#collapseAction-${action.actionName}`"
        :aria-controls="`collapseAction-${action.actionName}`"
        @click="didClickExpandAction(action.actionName)"
      >
        <div
          class="col d-flex align-items-center justify-content-between flex-grow-1"
        >
          <div
            v-if="!selectedCategory"
            class="d-flex align-items-start text-start w-100"
          >
            <div
              class="collapsed d-flex justify-content-between align-items-start w-100 mb-0 fs-5"
            >
              <div class="d-flex flex-column w-100">
                <span class="me-2">
                  {{ actionTitle }}
                </span>
                <ActionListHeaderDetails
                  :numberOfUsersThatHaveResponded="
                    numberOfUsersThatHaveResponded
                  "
                  :numberOfUsersSelectedActions="numberOfUsersSelectedActions"
                  :action="action"
                  :isFreeTextAction="isFreeTextAction"
                />
              </div>
              <i
                class="bi bi-chevron-down fs-3 mt-1 hide-fullscreen"
                :class="
                  isExpandedAction
                    ? 'rotate-icon-upward'
                    : 'rotate-icon-downward'
                "
              ></i>
            </div>
          </div>
          <p v-else class="mb-0 fs-5">
            <span class="me-2">
              {{ actionTitle }}
            </span>
            <ActionListHeaderDetails
              :numberOfUsersThatHaveResponded="numberOfUsersThatHaveResponded"
              :numberOfUsersSelectedActions="numberOfUsersSelectedActions"
              :action="action"
              :isFreeTextAction="isFreeTextAction"
            />
          </p>
        </div>
      </div>
    </div>
    <div
      v-if="!selectedCategory"
      :id="`collapseAction-${action.actionName}`"
      class="collapse-action collapse"
      :class="isExpandedAction ? 'collapsing show' : 'collapsing hide'"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
import ActionListHeaderDetails from './ActionListHeaderDetails.vue'

export default {
  name: 'ActionListExpandable',
  components: {
    ActionListHeaderDetails
  },
  //this component needs a slot
  props: {
    action: {
      type: Object,
      default: () => {}
    },
    didClickExpandAction: {
      type: Function,
      default: () => {}
    },
    isExpandedAction: {
      type: Boolean,
      default: false
    },
    numberOfUsersSelectedActions: {
      type: Number,
      default: 0
    },
    categories: {
      type: Object,
      default: () => {}
    },
    numberOfUsersThatHaveResponded: {
      type: Number,
      default: 0
    },
    selectedCategory: {
      type: String,
      default: ''
    },
    isFreeTextAction: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      shouldExpandAll: false
    }
  },
  computed: {
    actionTitle() {
      return this.action.title || this.$tr(this.action.messages, 'title')
    }
  }
}
</script>

<style lang="scss" scoped>
.collapse-action {
  border-top: 1px solid var(--kt-border-color);
  &.collapsing {
    overflow: hidden !important;
    display: block !important;
    transition: height 0.2s ease !important;
    &.hide {
      border: none;
      height: 0px !important;
    }
  }
  &:not(.collapsing) {
    &.hide {
      display: none !important;
    }
  }
}
.rotate-icon-upward {
  transform: rotate(180deg);
  transition: all 0.2s ease;
}
.rotate-icon-downward {
  transform: rotate(0deg);
  transition: all 0.2s ease;
}
</style>
